/* tslint:disable */

/**
 */
export class TimeBasedResult {
    points?: number;
    top?: number;
    int?: number;
    bot?: number;
    average?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/time-based-result.ts